export function hasEnabledFeature(userState, feature) {
    var _a;
    return (_a = userState === null || userState === void 0 ? void 0 : userState.enabledFeatures.includes(feature)) !== null && _a !== void 0 ? _a : false;
}
